import { Disclosure } from '@headlessui/react';
import { isEmpty } from 'lodash';
import clsx from 'clsx';
import type { ReactElement } from 'react';

import { AccordionBlockType } from '@/lib/types';
import { BaseBlock } from '@/components/base-block';
import { BlockHeader } from '@/components/block-header';
import { StructuredText } from '@/components/structured-text';
import { Icon } from '../icon';

const AccordionBlock = ({ items, title, theme, anchor }: AccordionBlockType): ReactElement | null => {
  if (isEmpty(items)) {
    return null;
  }

  return (
    <BaseBlock className="accordion" width="Narrow" theme={theme} anchor={anchor} hasContentPadding={false}>
      <BlockHeader title={title} />

      <ul className="items">
        {items.map((item) => {
          return (
            <Disclosure key={item.id}>
              {({ open }) => (
                <li
                  className={clsx('item', {
                    active: open,
                  })}
                >
                  <Disclosure.Button className="toggle-header">
                    <div className="field-heading body-2">{item.title}</div>
                    <Icon data-open className="fa-md toggle-icon" name={open ? 'chevron-up' : 'chevron-down'} />
                  </Disclosure.Button>

                  <Disclosure.Panel className="toggle-content">
                    <div className="row">
                      <div className="component content col-12">
                        <div className="component-content">
                          <div className="field-content body-4">
                            <StructuredText data={item.content} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Disclosure.Panel>
                </li>
              )}
            </Disclosure>
          );
        })}
      </ul>
    </BaseBlock>
  );
};

export { AccordionBlock };
